module.exports = __webpack_public_path__ + "static/img/5.43f32da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/sp/5.png
// module id = cKbd
// module chunks = 0